import styled from '@emotion/styled'
import rgba from 'color-alpha'

import { Box } from '../uiKit/components/Box'

// TODO: this needs better name
export const TransparentLineEnd = styled(Box)`
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  width: ${({ w }) => w ?? '45px'};
  background: linear-gradient(
    to left,
    ${({ theme, color = theme.ui.colors['white.100'] }) => color},
    ${({ theme, color = theme.ui.colors['white.100'] }) => color} 25%,
    ${({ theme, color = theme.ui.colors['white.100'] }) => rgba(color, 0)} 75%
  );
`
